import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-69f460b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "conversation__message-input-container" };
const _hoisted_3 = {
    class: "conversation__message-form-panel",
    style: { "padding-left": "14px" }
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "conversation__message-input-container" };
const _hoisted_6 = {
    class: "conversation__message-form-panel",
    style: { "padding-left": "14px" }
};
import { onMounted, ref } from "vue";
import { FormTypes } from "@/types/FormTypes";
import { t } from "@/utils/lang.util";
// import { toast } from "../main"
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConversationItemForm',
    props: {
        message: {
            type: Object,
            default: null,
            required: true
        },
        immutable: {
            type: Boolean,
            default: false
        }
    },
    emits: ['submit', 'dismiss'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const form = ref({});
        // const input = ref('')
        // const successMsg = computed(() => {
        //   return t('')
        // })
        // const doToast = () => {
        //   toast.show(t('common.toast.generic_error'));
        // }
        const formSubmitted = (obj) => {
            form.value['submitResult'] = obj.success;
            form.value['submitData'] = obj.data;
            emits('submit', obj);
        };
        const formDismissed = (obj) => {
            emits('dismiss', obj);
        };
        onMounted(() => {
            try {
                form.value = props.message.options.form;
                if (form.value['type'] === FormTypes.PRECHAT) {
                    if (!form.value['headerTxt'])
                        form.value['headerTxt'] = t('forms.types.PRE_CHAT.description');
                }
                else if (form.value['type'] === FormTypes.CONTACT_DETAILS) {
                    if (!form.value['headerTxt'])
                        form.value['headerTxt'] = t('forms.types.CONTACT_DETAILS.description');
                }
            }
            catch (e) {
                console.error('form could not be loaded: ' + e);
            }
        });
        return (_ctx, _cache) => {
            const _component_BaseMessage = _resolveComponent("BaseMessage");
            const _component_BaseForm = _resolveComponent("BaseForm");
            return (form.value.type === _unref(FormTypes).PRECHAT)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_BaseForm, {
                                modelValue: form.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form).value = $event)),
                                "auto-focus": false,
                                endpoint: form.value.apiEndpoint,
                                onSubmit: formSubmitted
                            }, {
                                success: _withCtx(() => [
                                    _createVNode(_component_BaseMessage, { type: "success" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('forms.types.PRE_CHAT.default-success-msg')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                error: _withCtx(() => [
                                    _createVNode(_component_BaseMessage, { type: "error" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('forms.types.PRE_CHAT.default-error-msg')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue", "endpoint"])
                        ])
                    ])
                ]))
                : (form.value.type === _unref(FormTypes).CONTACT_DETAILS)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_BaseForm, {
                                    modelValue: form.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form).value = $event)),
                                    "auto-focus": true,
                                    endpoint: form.value.apiEndpoint,
                                    onSubmit: formSubmitted,
                                    onDismiss: formDismissed
                                }, {
                                    success: _withCtx(() => [
                                        _createVNode(_component_BaseMessage, { type: "success" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('forms.types.CONTACT_DETAILS.default-success-msg')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    error: _withCtx(() => [
                                        _createVNode(_component_BaseMessage, { type: "error" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('forms.types.CONTACT_DETAILS.default-error-msg')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "endpoint"])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true);
        };
    }
});
